import { makeStyles, Theme } from "@material-ui/core/styles";

interface StreakProps {
  isSelected?: boolean;
  isStreak?: boolean;
}

export const useStyles = makeStyles((theme?: Theme) => ({
  dayContainer: ({ isSelected, isStreak }: StreakProps) => ({
    backgroundColor: isSelected ? "#ECF3F8" : "none",
    borderRadius: "4px",
    padding: "6px 8px",
    "& .MuiTypography-root": {
      fontFamily: "Lato",
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(14),
      color: "#A2A9BD",
    },
    "& svg path": {
      fill: isStreak ? "url(#streak)" : "#D1D4DE",
    },
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      width: "15%",
    },
  }),
}));
